import React, { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { PiEyeLight, PiEyeSlash } from "react-icons/pi";

const SignUp = () => {
  const navigate = useNavigate();
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  const [showPassword, setShowPassword] = useState(false);
  const [showSecret, setShowSecret] = useState(false);

  const [formValue, setFormValue] = useState({
    email: "",
    mobileNumber: "",
    password: "",
    role: "Admin",
    secretKey: "",
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    const passwordRegex =
      /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$&*_])[A-Za-z\d!@#$&*_]{8,}$/;
    if (!passwordRegex.test(formValue.password)) {
      alert(
        "Password must be at least 8 - 15 characters long,\n contain one uppercase letter, one number, \n and one special character eg : !@#$&*_"
      );
      return;
    }

    try {
      let response = await fetch(`${SERVER_URL}/admin/register`, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formValue),
      });

      if (response.ok) {
        response = await response.json();
        alert(response.message);
        navigate("/signin");
      } else {
        response = await response.json();
        console.log(response);
        alert(response.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {}, []);

  return (
    <div className="mt-8 md:mx-auto md:w-full md:max-w-md bg-white rounded-lg sm:mx-2">
      <div className="w-[100px] m-auto mb-4">
        <img
          src="/images/logo.svg"
          alt="Aifinite Learning"
          className="w-full"
        />
      </div>
      <div
        className="bg-[#fff]
          shadow-lg rounded-md py-8 px-4 md:rounded-lg md:px-10"
        style={{
          border: "1px solid #CACFD2",
          boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
        }}
      >
        <div className="text-center">
          <p className="text-2xl font-bold">Sign Up</p>
        </div>

        <form className="flex flex-col gap-4" onSubmit={handleSignIn}>
          <p className="text-md mt-4 text-red-500">
            Sign up only if you are an instructor !!
          </p>

          <div className="mt-4">
            <label className="block text-gray-700 mb-2">Your Name</label>
            <input
              required
              type="text"
              name="name"
              placeholder="John Doe"
              className="w-full p-2 bg-gray-50 focus:bg-blue-50 rounded-md border border-gray-300 focus:outline-none"
              onChange={handleInput}
            />
          </div>

          <div className="mt-4">
            <label className="block text-gray-700 mb-2">Your Email</label>
            <input
              required
              type="email"
              name="email"
              placeholder="example@gmail.com"
              className="w-full p-2 bg-gray-50 focus:bg-blue-50 rounded-md border border-gray-300 focus:outline-none"
              onChange={handleInput}
            />
          </div>

          <div className="mt-4">
            <label className="block text-gray-700 mb-2">
              Your Mobile Number
            </label>
            <div className="flex">
              <span className="inline-flex items-center px-3 bg-gray-50 border border-gray-300 rounded-l-md">
                +91
              </span>
              <input
                required
                type="tel"
                name="mobileNumber"
                placeholder="9999999999"
                maxLength={10}
                minLength={10}
                className="w-full p-2 bg-gray-50 focus:bg-blue-50 border border-gray-300 rounded-r-md focus:outline-none"
                onChange={handleInput}
              />
            </div>
          </div>

          {formValue.mobileNumber.length === 10 && (
            <div className="mt-6">
              <label className="block text-gray-700 mb-2">
                Admin Secret Key
              </label>
              <div className="relative">
                <input
                  required
                  name="secretKey"
                  placeholder="********"
                  type={showSecret ? "text" : "password"}
                  className="w-full p-2 bg-gray-50 focus:bg-blue-50 border border-gray-300 rounded-md focus:outline-none"
                  onChange={handleInput}
                  minLength={10}
                />
                <span
                  className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSecret(!showSecret);
                  }}
                >
                  {showSecret ? <PiEyeSlash /> : <PiEyeLight />}
                </span>
              </div>
            </div>
          )}

          {formValue.secretKey.length >= 10 && (
            <div className="mt-6">
              <label className="block text-gray-700 mb-2">Your Password</label>
              <div className="relative">
                <input
                  required
                  name="password"
                  placeholder="********"
                  type={showPassword ? "text" : "password"}
                  className="w-full p-2 bg-gray-50 focus:bg-blue-50 border border-gray-300 rounded-md focus:outline-none"
                  onChange={handleInput}
                  minLength={8}
                  maxLength={15}
                />
                <span
                  className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
                  onClick={() => {
                    setShowPassword(!showPassword);
                  }}
                >
                  {showPassword ? <PiEyeSlash /> : <PiEyeLight />}
                </span>
              </div>
            </div>
          )}

          <div className="mt-6 flex justify-center">
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 rounded-md font-semibold hover:bg-blue-700 transition duration-200"
            >
              SIGN UP
            </button>
          </div>
        </form>

        <div className="mt-4 flex">
          <p className="mr-2">Already have an account?</p>
          <RouterLink to="/signin">
            <p className="ml-2 text-blue-600 font-medium hover:underline">
              Sign in
            </p>
          </RouterLink>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
